import { render, staticRenderFns } from "./NfPopover.vue?vue&type=template&id=70c12b4e&scoped=true&"
import script from "./NfPopover.vue?vue&type=script&lang=js&"
export * from "./NfPopover.vue?vue&type=script&lang=js&"
import style0 from "./NfPopover.vue?vue&type=style&index=0&id=70c12b4e&prod&lang=scss&scoped=true&"
import style1 from "./NfPopover.vue?vue&type=style&index=1&id=70c12b4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c12b4e",
  null
  
)

export default component.exports